import { NEW_VERSION_URL } from "./old-version-notice";

// Store cài đặt UI do bản V2 ghi (app này chỉ đọc):
// zalo-ui-settings = {"state":{"tagDisplay":"full","defaultInterface":"new"},"version":0}
const UI_SETTINGS_KEY = "zalo-ui-settings";

export function getUISettings() {
  try {
    const raw = localStorage.getItem(UI_SETTINGS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.state || typeof parsed.state !== "object") return null;
    return parsed.state;
  } catch (e) {
    return null;
  }
}

export function getDefaultInterface() {
  const state = getUISettings();
  const value = state && state.defaultInterface;
  return value === "new" || value === "old" ? value : null;
}

// Đã quá hạn đóng giao diện cũ: mặc định đẩy MỌI người sang V2.
// Đường thoát duy nhất: người dùng chủ động chọn "giao diện cũ" trong cài đặt bên V2
// (zalo-ui-settings.defaultInterface === "old") - nhóm này vẫn vào được V1 và sẽ thấy
// banner + dialog nhắc hạn.
// Trả về true khi đã redirect, để caller không bootstrap app nữa.
export function redirectToV2() {
  // Đang ở sẵn /v2 (vd SPA fallback trả về chính app này) -> dừng, tránh loop vô hạn.
  if (window.location.pathname.indexOf("/v2") === 0) return false;
  window.location.replace(NEW_VERSION_URL + window.location.search + window.location.hash);
  return true;
}
